module.exports = __webpack_public_path__ + "img/collection-coppieee-com_2.4847d1a8.png";